import factory from './factory';

export default factory({
  cardNumber: 'last_digits',
  cardHolderName: 'holder_name',
  cardHolderType: 'holder_type',
  cardHolderEmail: 'holder_email',
  stripeSource: 'stripe_source',
});
